import { ISiteSettings } from '@sravni/types/lib/sitesettings';

import { IGlobalState } from '../index';

export const getSiteSettings = (state: IGlobalState): ISiteSettings => state.sitesettings;
